/**
 * @generated SignedSource<<cac9b88dcb0e047d85c893dbe80470f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoComments$data = {
  readonly influencerCommentReadTime: {
    readonly id: string;
    readonly readableId: string | null;
    readonly unreadCommentCount: number;
  } | null;
  readonly lastComment: {
    readonly action: string | null;
    readonly content: string | null;
  } | null;
  readonly " $fragmentType": "TodoComments";
};
export type TodoComments$key = {
  readonly " $data"?: TodoComments$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoComments">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoComments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "lastComment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "action",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentReadTime",
      "kind": "LinkedField",
      "name": "influencerCommentReadTime",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "readableId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unreadCommentCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Post",
  "abstractKey": null
};

(node as any).hash = "5bdfcb2052b55f806d198a43f4b3eb25";

export default node;
